import { events, categories } from "@/mocks/events";
import type { GossipEvent } from "@/types/content";

export const eventList: GossipEvent[] = events;
export const categoryList = categories;

export function getEventBySlug(slug: string): GossipEvent | undefined {
  return eventList.find((item) => item.slug === slug);
}

export function getCategoryBySlug(slug: string) {
  return categoryList.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategoryBySlug(slug)?.name ?? "综合";
}

export function getEventsByCategory(slug: string): GossipEvent[] {
  return eventList.filter((item) => item.categorySlug === slug);
}

export function getEventsByIds(ids: string[]): GossipEvent[] {
  return ids
    .map((id) => eventList.find((item) => item.id === id))
    .filter((item): item is GossipEvent => Boolean(item));
}

export function getRelatedEvents(event: GossipEvent): GossipEvent[] {
  const byId = getEventsByIds(event.relatedIds);
  if (byId.length >= 3) return byId.slice(0, 3);
  const fallback = eventList.filter(
    (item) => item.id !== event.id && item.categorySlug === event.categorySlug,
  );
  const merged = [...byId];
  fallback.forEach((item) => {
    if (merged.length < 3 && !merged.some((m) => m.id === item.id)) {
      merged.push(item);
    }
  });
  return merged.slice(0, 3);
}

export function sortByHeat(list: GossipEvent[] = eventList): GossipEvent[] {
  return [...list].sort((a, b) => b.heat - a.heat);
}

export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function getEventPath(slug: string): string {
  return `/event/${slug}`;
}

export function getCategoryPath(slug: string): string {
  return `/category/${slug}`;
}

export function countByCategory(slug: string): number {
  return eventList.filter((item) => item.categorySlug === slug).length;
}

export function searchEvents(keyword: string): GossipEvent[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return eventList;
  return eventList.filter((item) => {
    const haystack = [
      item.title,
      item.summary,
      getCategoryName(item.categorySlug),
      ...item.tags,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(key);
  });
}